import {Routes} from '@angular/router';
import {RoomsListComponent} from '@pages/support/rooms-list/rooms-list.component';
import {SupportStreamingComponent} from '@pages/support/support-streaming/support-streaming.component';

export const SUPPORT_ROUTES: Routes = [
  {
    path: 'room/list',
    component: RoomsListComponent,
    data: {
      title: 'Rooms List',
      urls: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Support' },
      ],
    }
  },
  {
    path: 'room/:uuid',
    component: SupportStreamingComponent,
    data: {
      title: 'Support',
      urls: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Room List', url: '/support/room/list' },
        { title: 'Support' },
      ],
    }
  }
];
